import "../css/deferred.css";
import mediumZoom from 'medium-zoom'

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const $elemsShownOnOpen = document.getElementsByClassName('shown-on-mobile-menu-open');
    const $elemsHiddenOnOpen = document.getElementsByClassName('hidden-on-mobile-menu-open');

    const $mobileMenu = document.getElementById('mobile-menu');
    const $mobileMenuWrapper = document.getElementById('mobile-menu-wrapper');
    const $closeBtn = document.getElementById('mobile-menu-close-btn');
    const $openBtn = document.getElementById('mobile-menu-open-btn');

    $openBtn.addEventListener('click', openMobileMenu);
    $closeBtn.addEventListener('click', closeMobileMenu);

    function openMobileMenu() {
        $closeBtn.classList.remove('hidden');
        $openBtn.classList.add('hidden', 'md:flex');

        $mobileMenuWrapper.classList.remove('hidden');
        setTimeout(function() {
            $mobileMenu.classList.remove('translate-x-full');
            setTimeout(function() {
                for (let i = 0; i < $elemsShownOnOpen.length; i++) {
                    $elemsShownOnOpen[i].classList.remove('hidden');
                }
                for (let i = 0; i < $elemsHiddenOnOpen.length; i++) {
                    $elemsHiddenOnOpen[i].classList.add('hidden', 'md:flex');
                }
            }, 300);
        }, 20);
    }

    function closeMobileMenu() {
        $openBtn.classList.remove('hidden');
        $closeBtn.classList.add('hidden', 'md:flex');

        for (let i = 0; i < $elemsShownOnOpen.length; i++) {
            $elemsShownOnOpen[i].classList.add('hidden');
        }
        for (let i = 0; i < $elemsHiddenOnOpen.length; i++) {
            $elemsHiddenOnOpen[i].classList.remove('hidden');
        }

        $mobileMenu.classList.add('translate-x-full');
        setTimeout(function () {
            $mobileMenuWrapper.classList.add('hidden');
        }, 300);
    }
});


document.addEventListener("DOMContentLoaded", function() {
    const $openBtns = document.getElementsByClassName('language-selection-btn');
    const $modal = document.getElementById('language-selection-modal');
    const $modalBackdrop = $modal.getElementsByClassName('backdrop')[0];
    const $modalPanel = $modal.getElementsByClassName('panel')[0];
    const $closeBtn = $modal.getElementsByClassName('close')[0];

    const modalBackdropClasses = {
        'entering': ['ease-out', 'duration-300', 'opacity-100'],
        'leaving': ['ease-in', 'duration-200', 'opacity-0']
    };
    const modalPanelClasses = {
        'entering': ['ease-out', 'duration-300', 'opacity-100', 'translate-y-0', 'sm:scale-100'],
        'leaving': ['ease-out', 'duration-300', 'opacity-0', 'translate-y-4', 'sm:translate-y-0', 'sm:scale-95']
    };

    $modalBackdrop.classList.add(...modalBackdropClasses['leaving']);
    $modalPanel.classList.add(...modalPanelClasses['leaving']);

    for (let i = 0; i < $openBtns.length; i++) {
        $openBtns[i].addEventListener('click', openLanguageSelectionModal);
    }
    $closeBtn.addEventListener('click', closeLanguageSelectionModal);
    $modalBackdrop.addEventListener('click', closeLanguageSelectionModal);

    function openLanguageSelectionModal() {
        $modal.classList.remove('hidden');

        setTimeout(function() {
            $modalBackdrop.classList.remove(...modalBackdropClasses['leaving']);
            $modalBackdrop.classList.add(...modalBackdropClasses['entering']);
            $modalPanel.classList.remove(...modalPanelClasses['leaving']);
            $modalPanel.classList.add(...modalPanelClasses['entering']);
        }, 20);
    }

    function closeLanguageSelectionModal() {
        $modalBackdrop.classList.remove(...modalBackdropClasses['entering']);
        $modalBackdrop.classList.add(...modalBackdropClasses['leaving']);
        $modalPanel.classList.remove(...modalPanelClasses['entering']);
        $modalPanel.classList.add(...modalPanelClasses['leaving']);

        setTimeout(function() {
            $modal.classList.add('hidden');
        }, 200);
    }
});

// Disabled zoom feature for now
// document.addEventListener("DOMContentLoaded", function() {
//     mediumZoom('[data-zoom-src]', {
//         container: {
//             top: 68,
//             bottom: 0,
//             right: 0,
//             left: 0,
//         },
//     });
// });